




import Meter from "@/components/Meter.vue";
import getHydraTotalItems from "@/service/TotalItemsProvider";

export default {
  name: "Projects",
  components: {
    Meter
  },
  data: () => {
    return {
      result: ''
    }
  },
  mounted() {
    getHydraTotalItems((this as any).$api, '/projects')
      .then((result: string) => ((this as any).result = result))
  },
}
